import React from "react";
import { KgNodePanelTabs } from "../KgNodePanelTabs";
import {
  KgListFilterHeader,
  KgListShell,
  KgListTableSection,
} from "./KgListPageLayout.styles";
import type { KgListPageLayoutProps } from "./KgListPageLayout.types";

export const KgListPageLayout: React.FC<KgListPageLayoutProps> = ({
  filterAriaLabel,
  tabs,
  activeTab,
  onTabChange,
  children,
  className,
  "data-testid": dataTestId,
}) => (
  <KgListShell className={className} data-testid={dataTestId}>
    <KgListFilterHeader aria-label={filterAriaLabel}>
      <KgNodePanelTabs
        tabs={[...tabs]}
        activeTab={activeTab}
        onChange={onTabChange}
        fitContent
        density="compact"
      />
    </KgListFilterHeader>
    <KgListTableSection>{children}</KgListTableSection>
  </KgListShell>
);

export default KgListPageLayout;
